const handles = [
  "horno-electrico-empotrable",
  "encimera-induccion",
  "termo-electrico-80",
  "campana-extractora",
  "purificador-aire",
  "griferia-cocina",
]
export function isDemoCatalogImage(url?: string | null) {
  return !!url && /^http:\/\/localhost:8000\/images\/catalog\//.test(url)
}
export default function DemoCatalogImage({
  handle,
  label,
  className = "",
}: {
  handle: string
  label: string
  className?: string
}) {
  const tile = Math.max(
    0,
    handles.findIndex((value) => handle.includes(value))
  )
  return (
    <div
      role="img"
      aria-label={label}
      className={`aspect-square w-full ${className}`}
      style={{
        backgroundImage: 'url("/images/catalog.png")',
        backgroundSize: "300% 200%",
        backgroundPosition: `${(tile % 3) * 50}% ${
          Math.floor(tile / 3) * 100
        }%`,
        backgroundRepeat: "no-repeat",
      }}
    />
  )
}
